export const HERO = {
  headline: "Escape the City. Build Your Dream Farmhouse.",
  subheadline:
    "Exclusive 36 Farmhouse Plots | 4000-5500 Sq. Ft. Each | Ghatiyabhana Village / Sonkatch",
  background:
    "https://images.unsplash.com/photo-1781816928317-d1de725e16be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBncmVlbiUyMGZhcm1sYW5kJTIwcGxvdCUyMG5hdHVyZSUyMGFlcmlhbCUyMGZhcm18ZW58MHx8fHwxNzkxOTgxNzIwfDA&ixlib=rb-4.1.0&q=85",
};

export const ABOUT = {
  title: "Why Choose Aaroh Farms?",
  intro:
    "A serene getaway crafted for those who crave calm. Aaroh Farms is a boutique gated community of just 36 farmhouse plots, nestled in nature's lap — a place to build, grow, and breathe. Spend peaceful weekends amid organic farms, open skies, and fresh air, far from the noise of the city yet effortlessly connected.",
  image: "/about-family.jpg",
  pillars: [
    {
      title: "Turn Your Farmhouse Into an Income-Generating Asset",
      tagline: "A Premium Getaway That Offers More Than Just a Place to Stay.",
      body: [
        "Aaroh Farms brings together a serene natural setting, premium amenities, and an escape from the everyday hustle — making it an attractive choice for guests seeking private weekend getaways. Create opportunities for rental income while owning a space that people would love to experience.",
        "Strategically located between the growing cities of Indore and Bhopal, Aaroh Farms offers the appeal of a peaceful countryside retreat with access to two important urban markets.",
      ],
      closing: "Own a destination people want to return to.",
      punch: "Premium surroundings. Memorable stays. Rental potential.",
      icon: "IndianRupee",
    },
    {
      title: "Invest in a Location With Room to Grow",
      tagline:
        "Between Indore and Bhopal, Discover the Value of a Countryside Investment.",
      body: [
        "Aaroh Farms is located at Ghatiyabhana Village, Sonkatch — a peaceful destination nestled amidst greenery, positioned between two of Madhya Pradesh's prominent urban centres.",
        "As interest in lifestyle properties, weekend homes, and countryside escapes grows, strategically located land can offer an opportunity to participate in future regional development.",
        "With its premium farmhouse concept and natural surroundings, Aaroh Farms brings together lifestyle appeal and long-term investment potential.",
      ],
      closing: "Choose a property that aligns with your vision for the future.",
      punch:
        "An emerging lifestyle destination. A location worth exploring. An investment to evaluate for the long term.",
      icon: "TrendingUp",
    },
    {
      title: "Escape the City. Reconnect With What Matters.",
      tagline: "Your Private Weekend Retreat, Surrounded by Nature.",
      body: [
        "Imagine waking up to fresh air, spending unhurried mornings amidst greenery, enjoying meals with your family, and watching the sunset without the noise and rush of city life.",
        "At Aaroh Farms, premium farmhouse living meets the tranquillity of the countryside. Designed for those who value privacy, comfort, and meaningful experiences, it offers a place to slow down, reconnect with loved ones, and make every weekend feel special.",
        "Whether it's a family gathering, a peaceful break from work, or simply time for yourself, Aaroh Farms gives you a reason to step away from the ordinary.",
      ],
      closing: "More than a farmhouse. Your own little escape from the city.",
      punch: "Breathe deeper. Live slower. Make weekends memorable.",
      icon: "Sun",
    },
  ],
};

export const AMENITIES = {
  title: "Amenities & Features",
  subtitle: "Everything in place for a secure, comfortable farmhouse life.",
  items: [
    {
      name: "Prime Location",
      icon: "MapPin",
      desc: "At Ghatiyabhana Village near the Bhopal–Indore 4-lane highway.",
    },
    {
      name: "Secure Gated Community",
      icon: "ShieldCheck",
      desc: "Fully gated with a solid boundary wall around the development.",
    },
    {
      name: "Electricity & Water Supply",
      icon: "Zap",
      desc: "Ready infrastructure with power and water connections.",
    },
    {
      name: "30 ft Wide Internal Roads",
      icon: "Route",
      desc: "Spacious, well-planned internal roads for easy access.",
    },
    {
      name: "Lush Green Landscaping",
      icon: "Trees",
      desc: "Extensive tree plantation and green landscaping throughout.",
    },
    {
      name: "High Appreciation",
      icon: "TrendingUp",
      desc: "A safe, growth-oriented land investment for the future.",
    },
  ],
};

export const LOCATION = {
  title: "Strategically Located in Nature's Lap",
  address:
    "Ghatiyabhana Village, Sonkatch, Madhya Pradesh",
  mapEmbed:
    "https://maps.google.com/maps?q=Sonkatch,%20Madhya%20Pradesh&t=&z=13&ie=UTF8&iwloc=&output=embed",
  distances: [
    { label: "Bhopal–Indore 4-Lane Highway", value: "Direct Connectivity" },
    { label: "Pappu & Pappu Dhaba", value: "7 km" },
    { label: "Dewas", value: "33 km" },
    { label: "Pushpgiri Jain Tirth", value: "8.5 km" },
  ],
};

export const GALLERY = {
  title: "Glimpse of Aaroh Farms",
  subtitle: "A preview of the landscape, layout, and lifestyle that awaits.",
  images: [
    {
      url: "https://images.unsplash.com/photo-1634241231821-5e1287fa8836?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBncmVlbiUyMGZhcm1sYW5kJTIwcGxvdCUyMG5hdHVyZSUyMGFlcmlhbCUyMGZhcm18ZW58MHx8fHwxNzkxOTgxNzIwfDA&ixlib=rb-4.1.0&q=85",
      title: "Master Layout & Green Topography",
      category: "Plots & Aerial View",
    },
    {
      url: "https://images.unsplash.com/photo-1771509498805-b3e47a1e5399?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxvcmdhbmljJTIwcGxhbnRhdGlvbiUyMGdyZWVuJTIwdHJlZXMlMjBlc3RhdGUlMjBsYW5kc2NhcGV8ZW58MHx8fHwxNzkxOTgxNzI4fDA&ixlib=rb-4.1.0&q=85",
      title: "Organic Plantation & Serene Living",
      category: "Landscape & Flora",
    },
    {
      url: "https://images.unsplash.com/photo-1764149205840-790b62492b4a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxvcmdhbmljJTIwcGxhbnRhdGlvbiUyMGdyZWVuJTIwdHJlZXMlMjBlc3RhdGUlMjBsYW5kc2NhcGV8ZW58MHx8fHwxNzkxOTgxNzI4fDA&ixlib=rb-4.1.0&q=85",
      title: "Lush Green Surroundings",
      category: "Landscape",
    },
    {
      url: "https://images.unsplash.com/photo-1775234581232-42c14b7aff61?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBncmVlbiUyMGZhcm1sYW5kJTIwcGxvdCUyMG5hdHVyZSUyMGFlcmlhbCUyMGZhcm18ZW58MHx8fHwxNzkxOTgxNzIwfDA&ixlib=rb-4.1.0&q=85",
      title: "Wide Internal Roads & Boundaries",
      category: "Infrastructure",
    },
    {
      url: "https://images.unsplash.com/photo-1673967314522-2d3a2e714090?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBydXN0aWMlMjBmYXJtaG91c2UlMjBhcmNoaXRlY3R1cmUlMjBsYW5kc2NhcGV8ZW58MHx8fHwxNzkxOTgxNzIwfDA&ixlib=rb-4.1.0&q=85",
      title: "Boutique Farmhouse Villa Concept",
      category: "Architecture Design",
    },
    {
      url: "https://images.unsplash.com/photo-1686710420447-4bc82c1f8998?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxvcmdhbmljJTIwcGxhbnRhdGlvbiUyMGdyZWVuJTIwdHJlZXMlMjBlc3RhdGUlMjBsYW5kc2NhcGV8ZW58MHx8fHwxNzkxOTgxNzI4fDA&ixlib=rb-4.1.0&q=85",
      title: "Exclusive 4000-5500 Sq. Ft. Plots",
      category: "Plot Border",
    },
  ],
};

export const CONTACT = {
  office: "Indore Bhopal Main Road, Near Mahindra Finance, Sonkatch, MP",
  phone: "8518002222",
  email: "aarohfarmsinfo@gmail.com",
  instagram: "aarohfarmsinfo",
  instagramUrl: "https://www.instagram.com/aarohfarmsinfo",
};

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Amenities", href: "#amenities" },
  { label: "Location", href: "#location" },
  { label: "Layout", href: "#project-plan" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export const URGENCY = {
  tickers: [
    "⚡ Only 36 plots in this launch — inventory is filling fast",
    "🎁 Exclusive launch-phase benefits & pre-launch pricing — limited window",
    "📈 Prices set to rise after launch — lock today's rate now",
    "🔑 A few prime-facing plots left — don't miss your spot",
  ],
  popup: {
    badge: "Limited Launch Offer",
    title: "Don't Miss the Launch Advantage",
    points: [
      "Only 36 exclusive plots — once they're gone, they're gone.",
      "Lock exclusive launch-phase pricing before the public rate hike.",
      "Early buyers get priority plot selection & launch benefits.",
    ],
    cta: "Book My Site Visit Now",
  },
};
